import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=37e1d304&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=37e1d304&lang=less&scoped=true&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=37e1d304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1d304",
  null
  
)

export default component.exports